import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Postcleaning from '../../components/Postcleaning/Postcleaning'

const Postcleaningpage = () => {
    return (
        <div>
        <Navbar/>
        <Postcleaning/>


        <Footer/>

        </div>
    )
}

export default Postcleaningpage